import request from '@/utils/request'
// 兑换卡-查看个数
export function cardCount(data) {
  return request({
    url: '/card/check_card_count',
    method: 'post',
    data: data
  })
}

// 兑换卡-查看个数
export function getCardList(data) {
  return request({
    url: '/card/get-list',
    method: 'post',
    data: data
  })
}

// 兑换卡-生成新兑换卡
export function createNewCard(data) {
  return request({
    url: '/card/make_card',
    method: 'post',
    data: data
  })
}

// 获取工业或服务商公司列表
export function getCompanyList(data) {
  return request({
    url: '/card/company_list',
    method: 'post',
    data: data
  })
}

// 月账单表格信息
export function getMonthBill(data) {
  return request({
    url: '/card/month_bill',
    method: 'post',
    data: data
  })
}

// 交易明细
export function getBillInfo(data) {
  return request({
    url: '/card/deal_detail',
    method: 'post',
    data: data
  })
}

// 兑换卡列表-备注更改接口
export function changeCardExtro(data) {
  return request({
    url: '/card/edit_card_memo',
    method: 'post',
    data: data
  })
}
